module.exports = __webpack_public_path__ + "static/media/shield.21e37010.svg";